import { render, staticRenderFns } from "./MenuTree.vue?vue&type=template&id=94aecfa4&scoped=true&"
import script from "./MenuTree.vue?vue&type=script&lang=ts&"
export * from "./MenuTree.vue?vue&type=script&lang=ts&"
import style0 from "./MenuTree.vue?vue&type=style&index=0&id=94aecfa4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94aecfa4",
  null
  
)

export default component.exports